/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Lottie from 'react-lottie';

import { ContainerStudies, ContainerLoading } from './style.js';
import Loading from '../../../assets/loading.json';
import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';

import api from '../../../services/api.js';

import ButtonDefault from '../../../components/ButtonDefault/index.js';
import InputDefault from '../../../components/InputDefault/index.js';
import ButtonAction from '../../../components/ButtonAction/index.js';
import ModalDelete from '../../../components/Modals/ModalDelete/index.js';
import ModalAdd from '../../../components/Modals/ModalAdd/index.js';
import ModalEdit from '../../../components/Modals/ModalEdit/index.js';

const SubClassList = () => {
  document.title = 'Enermerco - SubClasses';

  const [isLoading, setIsLoading] = useState(true);

  const [subClassList, setSubClassList] = useState([]);

  const [idDm006, setIdDm006] = useState('');
  const [subClassName, setSubClassName] = useState('');

  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalSubClassDesc, setModalEnergyFlagDesc] = useState('');
  const [modalNumber1, setModalNumber1] = useState('');

  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: Loading
  };

  const applyFilter = (idDm006, subClassName) => {
    let url = 'sub_class?';
    if (idDm006 !== '') {
      url += `&id=${idDm006}`;
    }
    if (subClassName !== '') {
      url += `&nome=${subClassName}`;
    }
    api
      .get(url)
      .then((response) => {
        setSubClassList(response.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchFilter = useCallback(() => {
    applyFilter(idDm006, subClassName);
  }, [idDm006, subClassName]);

  const cleanFields = useCallback(() => {
    setIdDm006('');
    setSubClassName('');
    applyFilter('', '');
  }, [idDm006, subClassName]);

  const deleteSubclass = useCallback(
    (id) => {
      api
        .delete(`sub_class?id=${id}`)
        .then((response) => {
          setModalDelete(false);
          if (response.status === 200) {
            toast.success('Subclasse removida com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          cleanFields();
          setModalDelete(false);
          toast.success(error);
        });
    },
    [modalDelete]
  );

  const addSubClass = useCallback(
    (modalText, modalNumber1) => {
      api
        .post(`sub_class`, {
          NM_SUBCLASSE: modalText.toUpperCase(),
          QT_DISPONIBILDIADE_KWH: parseFloat(modalNumber1.replace(',', '.'))
        })
        .then((response) => {
          setModalAdd(false);
          if (response.status === 201) {
            toast.success('Subclasse adicionada com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          setModalAdd(false);
          toast.success(error);
        });
    },
    [modalAdd]
  );

  const editSubClass = useCallback(
    (modalText, modalNumber1, _modalNumber2, _modalNumber3, id, modalStatus) => {
      api
        .put(`sub_class?id=${id}`, {
          NM_SUBCLASSE: modalText.toUpperCase(),
          QT_DISPONIBILDIADE_KWH: parseFloat(modalNumber1.replace(',', '.'))
        })
        .then((response) => {
          setModalEdit(false);
          if (response.status === 201) {
            toast.success('Registro alterado com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          setModalEdit(false);
          toast.success(error);
        });
    },
    [modalEdit]
  );

  useEffect(() => {
    applyFilter(idDm006, subClassName);
  }, []);

  return (
    <>
      <AuthGuard />
      <Menu />
      {isLoading ? (
        <ContainerLoading>
          <Lottie options={loadingAnimation} style={{ width: '100%', height: 400 }} />
          <h1>Carregando Subclasses...</h1>
        </ContainerLoading>
      ) : (
        <Container>
          <ContainerStudies>
            <h2>Lista de Subclasses</h2>
            <ButtonDefault
              Width={'150px'}
              Margin={'0px 30px 30px 0px'}
              Text="Adicionar"
              onClick={() => {
                setModalAdd(true);
              }}
            />
            <h3>Filtros</h3>
            <Row>
              <Col xs={3}>
                <InputDefault
                  placeholder="Código da Subclasse"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Código'}
                  value={`${idDm006}`}
                  onChange={(e) => setIdDm006(e.target.value)}
                />
              </Col>
              <Col xs={6}>
                <InputDefault
                  placeholder="Nome da Subclasse"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Nome'}
                  value={`${subClassName}`}
                  onChange={(e) => setSubClassName(e.target.value)}
                />
              </Col>
            </Row>
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Buscar"
              onClick={searchFilter}
            />
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Limpar"
              onClick={() => {
                cleanFields();
              }}
            />
            <Table striped bordered hover variant="light">
              <thead>
                <tr>
                  <th style={{ width: '5%', textAlign: 'right' }}>Código</th>
                  <th style={{ width: '20%' }}>Nome da Subclasse</th>
                  <th style={{ width: '5%', textAlign: 'center' }}>Ação</th>
                </tr>
              </thead>
              <tbody>
                {subClassList.map((subclass) => (
                  <tr>
                    <td style={{ textAlign: 'right' }}>{subclass.ID_DM006}</td>
                    <td>{subclass.NM_SUBCLASSE}</td>
                    <td
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '45px',
                        justifyContent: 'center'
                      }}>
                      <ButtonAction
                        Action="Edit"
                        onClick={() => {
                          setIdDm006(subclass.ID_DM006);
                          setModalEnergyFlagDesc(subclass.NM_SUBCLASSE);
                          setModalNumber1(
                            Number(subclass.QT_DISPONIBILDIADE_KWH).toFixed(2).replace('.', ',')
                          );
                          setModalEdit(true);
                        }}
                      />
                      <ButtonAction
                        Action="Remove"
                        onClick={() => {
                          setIdDm006(subclass.ID_DM006);
                          setModalEnergyFlagDesc(subclass.NM_SUBCLASSE);
                          setModalDelete(true);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ContainerStudies>
          <ToastContainer />
          <ModalDelete
            modalOpen={modalDelete}
            handleClose={() => setModalDelete(false)}
            handleConfirm={deleteSubclass}
            handleCancel={() => setModalDelete(false)}
            modalTitleText={`Deseja excluir a Subclasse #${idDm006}?`}
            modalText={modalSubClassDesc}
            id={idDm006}
          />
          <ModalAdd
            modalOpen={modalAdd}
            handleClose={() => setModalAdd(false)}
            handleConfirm={addSubClass}
            handleCancel={() => setModalAdd(false)}
            modalTitleText={'Adicionar nova Subclasse'}
            modalText={modalSubClassDesc}
            visibleText={true}
            visibleNumber1={false}
            placeHolderText={'Nome'}
            textLabel={'Nome da Subclasse'}
            number1Label={'Disponibilidade kWh'}
            placeHolderNumber1={'Disponibilidade kWh	'}
          />
          <ModalEdit
            modalOpen={modalEdit}
            handleClose={() => setModalEdit(false)}
            handleConfirm={editSubClass}
            handleCancel={() => setModalEdit(false)}
            modalTitleText={`Editar Distribuidora #${idDm006}`}
            visibleText={true}
            visibleNumber1={false}
            textLabel={'Nome da Subclasse'}
            id={idDm006}
            setModalText={setModalEnergyFlagDesc}
            modalText={modalSubClassDesc}
            number1Label={'Disponibilidade kWh	'}
            modalNumber1={modalNumber1}
            setModalNumber1={setModalNumber1}
            modalNumber2={''}
            setModalNumber2={() => {}}
            modalNumber3={''}
            setModalNumber3={() => {}}
          />
          <Footer />
        </Container>
      )}
    </>
  );
};

export default SubClassList;
